export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8080',
    ENDPOINTS: {
        UPLOAD: '/upload',
        CONVERSATION: '/conversation'
    }
};